import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import { ERadioColors } from '@enums/colors';
import { EAssetSiteA11yStatus, EBackhaulA11yStatus, EPowerSupplyA11yStatus } from '@enums/map';

export const tabsNames = {
	basicInformation: 'basicInformation',
	address: 'address',
	attributes: 'attributes',
};

export const basicInformationAreas = `
		"assetId assetId assetId contactPersonId contactPersonId contactPersonId"
		"assetType assetType assetType assetSubType assetSubType assetSubType"
		"uprn uprn uprn responsible responsible responsible"
		"price price maxOperators maxOperators height height"
		"lastDate lastDate lastDate siteDate siteDate siteDate"
		"notes notes notes notes notes notes"
		"submitButton submitButton submitButton submitButton submitButton submitButton"
		`;

export const addressAreas = `
		"adPropertyNoName adStreetName"
		"adLocality adTownCity"
		"adPostCode adPostCode"
		"ngr ngr"
		"coordFormat coordFormat"
		"lat lng"
		"locationDescription locationDescription"
		"buttons buttons"
		`;

export const backhaulStatusOptions = [
	{
		value: EBackhaulA11yStatus.red,
		label: 'Distance >15m or Need to Cross Rd',
		color: ERadioColors.red,
	},
	{
		value: EBackhaulA11yStatus.amber,
		label: 'Distance 5m-15m and Same Side Rd',
		color: ERadioColors.amber,
	},
	{
		value: EBackhaulA11yStatus.green,
		label: 'Distance <5m and Same Side Rd',
		color: ERadioColors.green,
	}];

export const powerStatusOptions = [
	{
		value: EPowerSupplyA11yStatus.red,
		label: 'Distance >15m or Need to Cross Rd',
		color: ERadioColors.red,
	},
	{
		value: EPowerSupplyA11yStatus.amber,
		label: 'Distance 5m-15m and Same Side Rd',
		color: ERadioColors.amber,
	},
	{
		value: EPowerSupplyA11yStatus.green,
		label: 'Distance <5m and Same Side Rd',
		color: ERadioColors.green,
	}];

export const assetStatusOptions = [
	{
		value: EAssetSiteA11yStatus.red,
		label: 'Out of service during construction work',
		color: ERadioColors.red,
	},
	{
		value: EAssetSiteA11yStatus.amber,
		label: 'Preservation area',
		color: ERadioColors.amber,
	},
	{
		value: EAssetSiteA11yStatus.green,
		label: 'Under offer',
		color: ERadioColors.green,
	}];

export const booleanOptions = [
	{
		value: true,
		label: 'Yes',
	},
	{
		value: false,
		label: 'No',
	},
];

export const EUniqEditModeKeysStatuses = {
	uniqKeyBackhaulAccessibility: 'uniqKeyBackhaulAccessibility',
	uniqKeyPowerSupplyAvailability: 'uniqKeyPowerSupplyAvailability',
	uniqKeySiteAvailability: 'uniqKeySiteAvailability',
} as const;

export type TUniqEditModeKeysStatuses = TValueOfStringRecord<typeof EUniqEditModeKeysStatuses>

export const EUniqEditModeKeysExists = {
	uniqKeyAssetAccessAvailability: 'uniqKeyAssetAccessAvailability',
	uniqKeyAssetSpecialImplementation: 'uniqKeyAssetSpecialImplementation',
} as const;

export type TUniqEditModeKeysExists = TValueOfStringRecord<typeof EUniqEditModeKeysExists>

export const fieldsToTestBasicInformation = [
	'assetId',
	'assetType',
	'subType',
	'uprn',
	'responsible',
	'indicativeAcceptablePricing',
	'maxOperators',
	'height',
	'assetOwnerNotes',
	'lastVerificationDate',
	'siteAvailabilityReviewDate',
];

export const fieldsToTestAddress = [
	'adPropertyNoName',
	'adStreetName',
	'adLocality',
	'adTownCity',
	'adPostCode',
	'lat',
	'lng',
	'locationDescription',
];

export const fieldsToTestAttributes = [
	'backhaulAccessibilityStatus',
	'backhaulAccessibilityDetails',
	'powerSupplyAvailabilityStatus',
	'powerSupplyAvailabilityDetails',
	'assetSiteAvailabilityStatus',
	'assetSiteAvailabilityDetails',
	'isAvailable',
	'assetAccessDetails',
	'specialImplementationIssuesExist',
	'specialImplementationIssueDetails',
];

export const formRequiredFieldNames: Record<string, string> = {
	subType: 'Subtype',
	uprn: 'UPRN',
	responsible: 'Responsible',
	height: 'Height',
	lastVerificationDate: 'Last Verification Date',
	siteAvailabilityReviewDate: 'Site Availability Review Date',
	assetOwnerNotes: 'Asset Owner Notes',
	adPropertyNoName: 'Property No./Name',
	adStreetName: 'Street Name',
	adLocality: 'Locality',
	adTownCity: 'Town/City',
	adPostCode: 'Postcode',
	locationDescription: 'Location Description',
	backhaulAccessibilityDetails: 'Backhaul Accessibility Details',
	powerSupplyAvailabilityDetails: 'Power Supply Availability Details',
	assetSiteAvailabilityDetails: 'Asset Site Availability Details',
	assetAccessDetails: 'Asset Access Details',
	specialImplementationIssueDetails: 'Special Implementation Issue Details',
};

export const excludeFieldsForEditMode: string[] = [
	'backhaulAccessibilityDetails',
	'powerSupplyAvailabilityDetails',
	'assetSiteAvailabilityDetails',
	'specialImplementationIssueDetails',
	'assetAccessDetails',
	'assetAccessDetailsFileIds',
	'backhaulAccessibilityDetailsFileIds',
	'assetSiteAvailabilityDetailsFileIds',
	'powerSupplyAvailabilityDetailsFileIds',
	'specialImplementationIssueDetailsFileIds',
];
